import { createAction } from 'redux-actions';
import { ActionTypes } from 'src/store/constants';


// ============ Gateway Actions ============

// Reset
export const resetGatewayState = createAction(ActionTypes.RESET_GATEWAY_STATE);

// Select gateway type
export const selectGateway = createAction(
    ActionTypes.GATEWAY_SELECT,
    (gatewayType) => gatewayType
);

// Set status
export const setGatewayStatus = createAction(
    ActionTypes.GATEWAY_SET_STATUS,
    (status) => status
);

// QR Modal
export const setGatewayQRModal = createAction(
    ActionTypes.GATEWAY_SET_QR_MODAL,
    (visible) => visible
);

// Active tab
export const setGatewayActiveTab = createAction(
    ActionTypes.GATEWAY_SET_ACTIVE_TAB,
    (tab) => tab
);

// Current step
export const setGatewayCurrentStep = createAction(
    ActionTypes.GATEWAY_SET_CURRENT_STEP,
    (step) => step
);

// Connect
export const gatewayConnect = createAction(ActionTypes.GATEWAY_CONNECT);
export const gatewayConnectSuccess = createAction(
    ActionTypes.GATEWAY_CONNECT_SUCCESS,
    (data) => data
);
export const gatewayConnectFailed = createAction(
    ActionTypes.GATEWAY_CONNECT_FAILED,
    (error) => error
);

// Disconnect
export const gatewayDisconnect = createAction(ActionTypes.GATEWAY_DISCONNECT);

// ============ Thunk Actions ============
// ============ NEW INIT ACTIONS ============

export const waInitCheckStart = () => ({
    type: ActionTypes.WA_INIT_CHECK_START,
});

export const waInitCheckSuccess = (data) => ({
    type: ActionTypes.WA_INIT_CHECK_SUCCESS,
    payload: data,
});

export const waInitCheckFailed = (error) => ({
    type: ActionTypes.WA_INIT_CHECK_FAILED,
    payload: error,
});

export const waInitUpdateStatus = (data) => ({
    type: ActionTypes.WA_INIT_UPDATE_STATUS,
    payload: data,
});

// // ============ THUNK ACTIONS ============

// // Disconnect WhatsApp
export const disconnectWhatsApp = () => {
    return async (dispatch) => {
        try {
            await fetch('/api/wa/disconnect', {
                method: 'POST',
            });
            dispatch(gatewayDisconnect());
            return { success: true };
        } catch (error) {
            console.error('Disconnect error:', error);
            dispatch(gatewayDisconnect());
            return { success: false, error: error.message };
        }
    };
};



